const isSandbox = true;
const SELECTED_HOTEL = "beaconGrand";
// Maps room upgrades.
// - Outermost key is hotel property this matrix is for.
//   - Next nested key is the current room code
//     - Final nested key is the room code we are upgrading to.
export const upgradeCostsMatrix = {
  beaconGrand: {
    CQQ: {
      GQQHV: 60,
      CQQHV: 35,
      GQQ: 40,
    },
    CK: {
      CKHV: 20,
      GK: 50,
      GKHV: 75,
      GJKS: 100,
    },
    GK: {
      GJKS: 35,
    },
    CKHV: {
      GKHV: 60
    }
  },
  sandBox: {
    CQQ: {
      GQQHV: 60,
      CQQHV: 35,
      GQQ: 40,
    },
    CK: {
      CKHV: 20,
      GK: 50,
      GKHV: 75,
      GJKS: 100,
    },
    GK: {
      GJKS: 35,
    },
    CKHV: {
      GKHV: 60
    }
  }
}

export function getAllowedUpgrades(upsellFromRoomCodes) {
  // Inner join upgradeTos instead of a left join. (only include upgradeTos that satisfy all selected rooms)
  const matrix = isSandbox ? upgradeCostsMatrix.sandBox : upgradeCostsMatrix.beaconGrand;
  let result = []
  let first = true;
  for (let code of upsellFromRoomCodes) {
    if (first) {
      result.push(...Object.keys(matrix[code]))
      first = false;
    } else {
      result = result.filter(rCode => Object.keys(matrix[code]).includes(rCode))
    }
  }

  return [...new Set(result)]
}

export function getAllowedUpgradeFroms(allRoomCodes) {
  const matrix = isSandbox ? upgradeCostsMatrix.sandBox : upgradeCostsMatrix.beaconGrand;
  return [...allRoomCodes.filter(code => Object.keys(matrix).includes(code))]
}

export function lookupUpgradePrice(fromCode, toCode) {
  return upgradeCostsMatrix[SELECTED_HOTEL][fromCode]?.[toCode] || 0
}